import { getEmployees } from '@/api/employee';
import { getWilayas } from '@/api/wilaya';
import { useState, useEffect } from 'react';

const useEmployeesAll = () => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getEmployees({});
        setEmployees(response);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching wilayas:', error);
        setLoading(false);
      }
    };

    fetchEmployees();
  }, []);

  return { employees, loading };
};

export default useEmployeesAll;
